import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=981b7f44&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=981b7f44&lang=scss&scoped=true&"
import style1 from "./stylev4.scss?vue&type=style&index=1&id=981b7f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981b7f44",
  null
  
)

component.options.__file = "Landing.vue"
export default component.exports